/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AttributeValueBase {
    __type: string;

    protected setDiscriminator(type: string) {
        this.__type = type;
    }

    getFixupPrototypeFunction() { return AttributeValueBase.fixupPrototype; }

    static newInstance(model: Partial<AttributeValueBase>): AttributeValueBase {
        let obj = Object.assign(new AttributeValueBase(), model);
        AttributeValueBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AttributeValueBase>): AttributeValueBase {
        if (!model) return null;
        return AttributeValueBase.newInstance(<AttributeValueBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AttributeValueBase) {
        if (!obj) return;

        models.AttributeValueBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AttributeValueBase): boolean {
        switch (obj.__type)
        {
            case "AttributeValueForBoolean":
                Object.setPrototypeOf(obj, models.AttributeValueForBoolean.prototype);
                break;
            case "AttributeValueForDateTime":
                Object.setPrototypeOf(obj, models.AttributeValueForDateTime.prototype);
                break;
            case "AttributeValueForNumber":
                Object.setPrototypeOf(obj, models.AttributeValueForNumber.prototype);
                break;
            case "AttributeValueForString":
                Object.setPrototypeOf(obj, models.AttributeValueForString.prototype);
                break;
        }
        return true; // Tell the caller this is a polymorphic type, it should not overwrite the prototype.
    }

    static getTypeHierarchy(): (typeof AttributeValueBase)[] {
        return [
            models.AttributeValueForBoolean,
            models.AttributeValueForDateTime,
            models.AttributeValueForNumber,
            models.AttributeValueForString,
        ];
    }

    fixupFields() {
    }

    /**
     * Name of the Attribute
     */
    name: string;

}
